import {
  Dialog,
  DialogContent,
  Spinner,
  DialogSurface,
  DialogBody,
  makeStyles,
} from "@fluentui/react-components";

const useStyles = makeStyles({
  body: {
    display: "flex",
    alignItems: "center",
    gap: "16px",
    fontSize: "1.3em",
    fontWeight: "600",
  },
});

export interface LoadingDialogProps {
  isOpen: boolean;
  message: string;
}

export default function LoadingDialog({ isOpen, message }: LoadingDialogProps) {
  const classes = useStyles();

  return (
    <Dialog open={isOpen} modalType="modal">
      <DialogSurface>
        <DialogBody>
          <DialogContent>
            <div className={classes.body}>
              <Spinner />
              <p>{message}</p>
            </div>
          </DialogContent>
        </DialogBody>
      </DialogSurface>
    </Dialog>
  );
}
